export default "__VITE_ASSET__b1f8cee5__"